import script from "./OrderPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderPopup.vue?vue&type=script&setup=true&lang=js"

import "./OrderPopup.vue?vue&type=style&index=0&id=0acd8f66&setup=true&lang=css"

const __exports__ = script;

export default __exports__